(() => {
  const init = (root) => {
    if (!root || root.dataset.zb13Ready === 'true') return;
    root.dataset.zb13Ready = 'true';

    const links = [...root.querySelectorAll('[data-zb13-anchor]')];
    const buyLink = root.querySelector('[data-zb13-buy]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (buyLink) {
      const productInfo = document.querySelector('[id^="ProductInformation-"]');
      if (productInfo?.id) {
        buyLink.href = `#${productInfo.id}`;
      }
    }

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const selector = link.getAttribute('href');
        const target = selector?.startsWith('#') ? document.querySelector(selector) : null;
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start',
        });
        history.replaceState(null, '', selector);
      });
    });

    if (buyLink) {
      buyLink.addEventListener('click', (event) => {
        const selector = buyLink.getAttribute('href');
        const target = selector?.startsWith('#') ? document.querySelector(selector) : null;
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      });
    }

    const observed = links
      .map((link) => ({ link, target: document.querySelector(link.getAttribute('href')) }))
      .filter((entry) => entry.target);

    if (!('IntersectionObserver' in window) || observed.length === 0) return;

    const visible = new Map();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => visible.set(entry.target.id, entry));
        const active = [...visible.values()]
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        links.forEach((link) => {
          const isCurrent = active && link.getAttribute('href') === `#${active.target.id}`;
          if (isCurrent) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      },
      { rootMargin: '-22% 0px -62% 0px', threshold: [0, 0.15, 0.35, 0.6] },
    );

    observed.forEach(({ target }) => observer.observe(target));
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-zb13-nav-root]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
bu